<template>
  <div class="cloud-page">
    <div v-if="isWeixin">
      <p>点击以下按钮打开 “HiPC小程序”</p>
      <wx-open-launch-weapp username="gh_c070b0d08936" :path="weappPath">
        <script type="text/wxtag-template">
          <style>
          .btn-click {
            width: 200px;
            height: 45px;
            text-align: center;
            font-size: 17px;
            display: block;
            margin: 100px auto 0;
            padding: 8px 24px;
            border: none;
            border-radius: 4px;
            background-color: #07c160;
            color:#fff;
          }
        </style>
        <button class="btn-click">打开小程序</button>
        </script>
      </wx-open-launch-weapp>
    </div>
    <template v-else-if="isMobile">
      <p>正在打开 “HiPC小程序”...</p>
      <button @click="openWeapp()" class="btn_click">打开小程序</button>
    </template>
    <template v-else-if="isDesktop">
      <p>请在手机打开网页链接</p>
    </template>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
const { initCloud } = require('@wxcloud/cloud-sdk')
const cloud = initCloud()

export default {
  name: "UnLock",
  data() {
    return {
      isWeixin: false,
      isDesktop: false,
      isMobile: false,
      c: null,
      // 存储从路由获取的参数
      routeParams: {}
    };
  },
  computed: {
    // 构建带参数的小程序路径
    weappPath() {
      const basePath = '/pages/home/index/index'
      // 如果有参数，构建查询字符串
      if (Object.keys(this.routeParams).length > 0) {
        const queryString = new URLSearchParams(this.routeParams).toString()
        return `${basePath}?${queryString}`
      }
      console.log(basePath)
      return basePath
    }
  },
  created() {
    // 获取当前页面的路由参数
    this.getRouteParams()

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      this.docReady()
    } else {
      document.addEventListener('DOMContentLoaded', this.docReady());
    }
  },
  methods: {
    // 获取当前页面的路由参数
    getRouteParams() {
      // 方式1：从 Vue Router 获取（如果使用）
      if (this.$route && this.$route.query) {
        this.routeParams = { ...this.$route.query }
      }

      // 方式2：直接从 URL 获取（作为补充）
      const urlParams = new URLSearchParams(window.location.search)
      const params = {}
      for (const [key, value] of urlParams.entries()) {
        params[key] = value
      }
      // 合并参数
      this.routeParams = { ...this.routeParams, ...params }

      // 打印参数方便调试
      console.log('传递到小程序的参数：', this.routeParams)
    },
    initWxConfig() {
      wx.config({
        // debug: true, // 调试时可开启
        appId: 'wx6265a35adb332603',
        timestamp: 0, // 必填，填任意数字即可
        nonceStr: 'nonceStr', // 必填，填任意非空字符串即可
        signature: 'signature', // 必填，填任意非空字符串即可
        jsApiList: ['chooseImage'], // 安卓上必填一个，随机即可
        openTagList:['wx-open-launch-weapp'], // 填入打开小程序的开放标签名
      })
    },
    async docReady(){
      const ua = navigator.userAgent.toLowerCase();
      const isWXWork = ua.match(/wxwork/i) == 'wxwork';
      const mobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|IEMobile)/i)
      if (!isWXWork && ua.match(/MicroMessenger/i) == 'micromessenger' && mobile) {
        this.initWxConfig()
        this.isWeixin = true
      } else if (mobile) {
        this.isMobile = true
        this.c = new cloud.Cloud({
          // 必填，表示是未登录模式
          identityless: true,
          // 资源方 AppID
          resourceAppid: 'wx6265a35adb332603',
          // 资源方环境 ID
          resourceEnv: 'hipc-1g1hfqfseeb4fce2',
        })
        await this.c.init()
        try {
          await this.openWeapp()
        } catch (e) {
          throw e
        }
      } else {
        this.isDesktop = true
      }
    },
    async openWeapp(onBeforeJump) {
      // 构建带参数的完整路径
      const pathWithParams = this.weappPath
      console.log('打开小程序路径：', pathWithParams)

      const res = await this.c.callFunction({
        name: 'public',
        data: {
          action: 'getUrlScheme',
          path: pathWithParams // 将带参数的路径传递给云函数
        },
      })
      if (onBeforeJump) {
        onBeforeJump()
      }
      location.href = res.result.openlink
    }
  },
  beforeDestroy() {}
};
</script>

<style scoped>
.cloud-page {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.btn_click {
  width: 200px;
  height: 45px;
  text-align: center;
  font-size: 17px;
  display: block;
  margin: 100px auto 0;
  padding: 8px 24px;
  border: none;
  border-radius: 4px;
  background-color: #07c160;
  color:#fff;
}
</style>



// WEBPACK FOOTER //
// src/view/hipc/UnLock.vue